const mapRepListResult = ({ data, dataLength }) => {
	const mappedData = data.map((item) => {
		return {
			id: item._id,
			phoneNumber: item.phoneNumber,
			callCenterId: item.callCenterId,
		}
	});
	return {
		data: mappedData,
		total: dataLength
	};
};

const mapRepListToServiceModel = (data) => {
	const mappedData = data.map((item) => {
		const { tempId, phoneNumber, callCenterId } = item;

		return {
			_id: item.id,
			phoneNumber,
			callCenterId,
			tempId,
		}
	});
	return mappedData;
};

export {
	mapRepListResult,
	mapRepListToServiceModel,
};
